import { render, staticRenderFns } from "./provider-cards-list.vue?vue&type=template&id=50b33ad5&scoped=true&"
import script from "./provider-cards-list.vue?vue&type=script&lang=js&"
export * from "./provider-cards-list.vue?vue&type=script&lang=js&"
import style0 from "./provider-cards-list.vue?vue&type=style&index=0&id=50b33ad5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b33ad5",
  null
  
)

export default component.exports